---
date: 2022-08-11
title: Map in your language
---

The map labels are now displayed in your language, if available on OpenStreetMap.
